// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type CompanyInfoField_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoField_Region_Fragment = { __typename?: 'Region', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoField_Market_Fragment = { __typename?: 'Market', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoField_Community_Fragment = { __typename?: 'Community', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoField_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoField_Lot_Fragment = { __typename?: 'Lot', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoField_Structure_Fragment = { __typename?: 'Structure', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoField_Unit_Fragment = { __typename?: 'Unit', id: string, companyInfo: { __typename?: 'CompanyInfo', name: string, licenseNumber: string, email: string, phoneNumber: string, accountNumber: string, federalId: string } };

export type CompanyInfoFieldFragment =
  | CompanyInfoField_StandaloneProject_Fragment
  | CompanyInfoField_Region_Fragment
  | CompanyInfoField_Market_Fragment
  | CompanyInfoField_Community_Fragment
  | CompanyInfoField_Subdivision_Fragment
  | CompanyInfoField_Lot_Fragment
  | CompanyInfoField_Structure_Fragment
  | CompanyInfoField_Unit_Fragment
;

export const CompanyInfoFieldFragmentDoc = gql`
    fragment CompanyInfoField on Project {
  id
  companyInfo {
    name
    licenseNumber
    email
    phoneNumber
    accountNumber
    federalId
  }
}
    `;